import { Alert, AlertTitle } from '@mui/material'
import type { MotivoDoCashbackPendente } from '../../store/carrinho-slice'

interface AvisoCashbackPendenteProps {
  motivo: MotivoDoCashbackPendente
}

/**
 * O envio com cashback falhou e o valor pode ter saído do saldo sem a resposta chegar. Só reenviar o MESMO
 * pedido aproveita esse valor (ou devolve o pedido, se ele já foi gravado). Por isso o caminho é um só, o
 * "Enviar pedido" do rodapé, e o aviso não sugere pedir sem o cashback nem voltar ao início.
 */
export function AvisoCashbackPendente({ motivo }: AvisoCashbackPendenteProps): JSX.Element {
  // CASHBACK_INDISPONIVEL: o backend respondeu, e o pedido não foi gravado.
  if (motivo === 'INDISPONIVEL') {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        <AlertTitle>Seu pedido ainda não foi enviado</AlertTitle>
        Não conseguimos usar seu cashback. Toque em Enviar pedido de novo, sem mudar nada: assim seu cashback não é
        usado duas vezes.
      </Alert>
    )
  }

  // Rede, tempo esgotado ou 5xx: o pedido pode ter sido gravado. Reenviar igual devolve ele, sem duplicar.
  return (
    <Alert severity="warning" sx={{ mt: 2 }}>
      <AlertTitle>Não sabemos se seu pedido chegou</AlertTitle>
      Toque em Enviar pedido de novo, sem mudar nada: se ele já chegou, não sai outro pedido, e seu cashback não é usado
      duas vezes.
    </Alert>
  )
}
